import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Control chart setting'
  }
];

@Component({
  selector: 'page-control-chart-setting',
  templateUrl: './control-chart-setting.html',
  styleUrls: ['./control-chart-setting.scss']
})

export class PageControlChartSetting implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any="";
  ctcharts = [];
  //autoincreate
  filtered:any;
  ctrl:FormControl;
  items = [];

  //autoincreat spc item
  filteredSpecItems:any;
  ctrlSpecItems = new FormControl();
  itemsSpecItems = [];

  //form
  form: FormGroup;
  selectedProductCtrl = new FormControl();
  selectedLineCtrl = new FormControl();
  selectedLotCtrl = new FormControl();
  selectedModelCtrl = new FormControl();
  selectedProcessCtrl = new FormControl();
  selectedSymbolCtrl = new FormControl();
  ctrlSpec = new FormControl();
  filteredSpec:any;
  processs = [];lines=[];products=[];models=[];

  selectedItemsLine=[];
  selectedItemsModel=[];
  selectedItemsProcess=[];
  selectedItemsStand=[];
  dropdownSettings = { 
    singleSelection: true, 
    text:"Select",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"col-md-12"
  };  


  name:string;tool:string;spot:string;lcl:string;ucl:string;lsl:string;usl:string;id:string;samplingtime:string;line:string;model:string;process:string;standard:string;
  selectedProduct:string;selectedLine:string;selectedLot:string;selectedModel:string;selectedProcess:string;
  xbar:String;rbar:String;uclr:String;cpk:String;cp:String;
  ckedit:boolean=false;tb87_id:String;
  lots = [];
  //upload
  fileupload:string;
  //data table
  data:any;
  rows = [];temp=[];
  //upload file
  imageSrc:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  Name:string; 
  myFile:File; /* property of File type */

  //dialog
  dialogRefWarning: MdDialogRef<WarningControlChartSettingDialog>;
  dialogRef: MdDialogRef<controlChartSettingDialog>;
  setId:any;
  symbols=[];
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/control-chart-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/control-chart-list-export.php";
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.getSearchCtChart();
    this.getProcess();
    this.getProduct();
    this.getModels();
    this.getLine();
    this.getStartData();
    this.getSymbol();
    this.getControlType();
    this._sharedService.emitChange(this.pageTitle);
  }

onItemSelect(item:any){
  console.log(this.selectedItemsLine);
}
OnItemDeSelect(item:any){}
onSelectAll(items: any){}
onDeSelectAll(items: any){}

getSymbol(){
    this.httpservice.fetchget('getJSON_symbol.php?', (data) => {
        this.symbols = data;
       
    });
}

getControlType(){
  this.httpservice.fetchget('getJSON_control_chart_type.php?', (data) => {
      this.lots = data;
     
  });
}
  intervalGetData(){
    return setInterval(() => {
      if(this.setId.runCount>5){
        clearInterval(this.setId);
        }
      this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);

  }

  getStartData(){
    this.httpservice.fetchget('getJSON_control_chart.php?',(ctchart) => {
      this.rows = ctchart;
      this.temp = ctchart;
      this.loadingIndicator = false;
      console.log('------this.machine------', this.key,ctchart,this.rows);
    });
  }


  getProcess(){
    this.httpservice.fetchget('getJSON_process.php?',(data)=>{
      //this.processs = data;
      for(let i = 0;i<data.length;i++){
        this.processs.push({"id":data[i].tpn_id,"itemName":data[i].tpn_name});
      }
    });
  }

  getStandardItem(id:String){
    
    this.tb87_id = id;

  }
  getProduct(){
    this.httpservice.fetchget('getJSON_product_standard.php?',(data)=>{
     // this.products = data;
      for(let i = 0;i<data.length;i++){
        this.products.push({"id":data[i].tb87f_id,"itemName":data[i].tb87f_name});
      }
    });
    this.ctrlSpec = new FormControl();
    this.filteredSpec = this.ctrlSpec.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.products.filter((s) => new RegExp(val, 'gi').test(s.tb87f_name)) : this.products;
    });
  }

  getModels(){
    this.httpservice.fetchget('getJSON_model.php?',(data)=>{
      //this.models = data;
      for(let i = 0;i<data.length;i++){
        this.models.push({"id":data[i].tp_id,"itemName":data[i].tp_productname});
      }
    });
  }
  
  getLine(){
    this.httpservice.fetchget('getJSON_line.php?',(data)=>{
      //this.lines = data;

      for(let i = 0;i<data.length;i++){
        this.lines.push({"id":data[i].tpr_id,"itemName":data[i].tpr_name});
      }
    });
  }

  getSearchCtChart(){
    this.httpservice.fetchget('getJSON_control_chart_name.php?',(ctchart) => {
      this.ctcharts = ctchart.map(function (val) {
        return [val.tb86f_ctc_name];
      });
      console.log('------this.machine------', this.lines);
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.ctcharts.filter((s) => new RegExp(val, 'gi').test(s)) : this.ctcharts;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteControlChart.php', val, (cb) => {});
  this.setId = this.intervalGetData();
  }
  setedit(id:string){
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_control_chart.php?id='+id,(ctchart) => {
      this.form.controls.name.setValue(ctchart[0].tb86f_ctc_name);
      this.form.controls.product.setValue(ctchart[0].tb86f_product_standard);
      this.form.controls.spot.setValue(ctchart[0].tb86f_spot);
      this.form.controls.tool.setValue(ctchart[0].tb86f_tool);
      this.form.controls.lcl.setValue(ctchart[0].tb86f_lcl);
      this.form.controls.lsl.setValue(ctchart[0].tb86f_lsl);
      this.form.controls.usl.setValue(ctchart[0].tb86f_usl);
      this.form.controls.ucl.setValue(ctchart[0].tb86f_ucl);
      this.form.controls.xbar.setValue(ctchart[0].tb86f_xbar);
      this.form.controls.cpk.setValue(ctchart[0].tb86f_cpk);
      this.form.controls.cp.setValue(ctchart[0].tb86f_cp);
      this.form.controls.rbar.setValue(ctchart[0].tb86f_rbar);
      this.form.controls.uclr.setValue(ctchart[0].tb86f_rucl);
      this.form.controls.remark.setValue(ctchart[0].tb86f_remark);
      this.form.controls.toolCode.setValue(ctchart[0].tb86f_tool_code);
      this.form.controls.samplingtime.setValue(ctchart[0].tb86f_sampling_time);
      this.selectedSymbolCtrl.setValue(ctchart[0].tb118_symbol_tb118f_id);
      //this.selectedLineCtrl.setValue(ctchart[0].line);
      this.selectedModelCtrl.setValue(ctchart[0].tb86f_model);
     //this.selectedProcessCtrl.setValue(ctchart[0].process);
      //this.selectedProductCtrl.setValue(ctchart[0].standard);
      this.selectedLine = ctchart[0].tb17_productionline_tpr_id;
      this.selectedLot = ctchart[0].tb86f_lot_check;
      this.selectedProcess = ctchart[0].tb20_process_name_tpn_id;
      this.selectedProduct = ctchart[0].tb87_standard;
      this.tb87_id = ctchart[0].tb87_standard;
      this.ctrlSpec.setValue(ctchart[0].standard);

      this.selectedItemsLine = ctchart[0].line;
      this.selectedItemsModel = ctchart[0].model;
      this.selectedItemsProcess = ctchart[0].process;
      this.selectedItemsStand = ctchart[0].standard;



      //this.selectedLineCtrl.setValue("71");
      //this.selected=process[0].process;
    });




  }
  edit(){
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }
    this.ckedit = false;
    this.data = {
      id:this.id,
      samplingtime:this.form.controls.samplingtime.value,
      name:this.form.controls.name.value,
      tool:this.form.controls.tool.value,
      tb118f_id:this.selectedSymbolCtrl.value,
      spot:this.form.controls.spot.value,
      lcl:this.form.controls.lcl.value,
      ucl:this.form.controls.ucl.value,
    lsl:this.form.controls.lsl.value,
    usl:this.form.controls.usl.value,
     // lsl:parseFloat(this.form.controls.limit.value)-parseFloat(this.form.controls.uncertainty_low.value),
     // usl:parseFloat(this.form.controls.limit.value)+parseFloat(this.form.controls.uncertainty_high.value),
      
      remark:this.form.controls.remark.value,
      toolCode:this.form.controls.toolCode.value,
      lot:this.selectedLotCtrl.value,
      xbar:this.form.controls.xbar.value,
      cpk:this.form.controls.cpk.value,
      cp:this.form.controls.cp.value,
      rbar:this.form.controls.rbar.value,
      uclr:this.form.controls.uclr.value,

      model:this.selectedItemsModel,
      line:this.selectedItemsLine,
      process:this.selectedItemsProcess,
      standard:this.selectedItemsStand,

      filename:this.fileupload
    }
    // insert data
    this.httpservice.fetchpost('editPostDataControlChart.php', this.data, (cb) => {});
      //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
    console.log('------edit ------');
    this.selectedProductCtrl.reset();
    this.selectedLineCtrl.reset();
    this.selectedLotCtrl.reset();
    this.selectedModelCtrl.reset();
    this.selectedProcessCtrl.reset();
    this.selectedSymbolCtrl.reset();

    this.selectedItemsStand = [];
    this.selectedItemsLine = [];
    this.selectedItemsProcess = [];
    this.selectedItemsModel = [];
    this.form.reset();
  }

  cancelEdit(){
    this.ckedit = false;
    this.selectedProductCtrl.reset();
    this.selectedLineCtrl.reset();
    this.selectedLotCtrl.reset();
    this.selectedModelCtrl.reset();
    this.selectedProcessCtrl.reset();
    this.selectedSymbolCtrl.reset();
    this.ctrlSpec.reset();
    this.ctrlSpecItems.reset();
    this.form.reset();
    this.selectedItemsStand = [];
    this.selectedItemsLine = [];
    this.selectedItemsProcess = [];
    this.selectedItemsModel = [];
  }
  getProcessInfo(val:string,_event: any,index:any){
    if(_event.isUserInput){
    this.process = val;
    console.log('process',this.process,val);
    }
  }
  getLineInfo(val:string,_event: any,index:any){
    if(_event.isUserInput){
    this.line = val;
    console.log('line',this.line,val);
    }
  }
  getModelInfo(val:string,_event: any,index:any){
    if(_event.isUserInput){
    this.model = val;
    console.log('model',this.model,val);
    }
  }
  getStandardInfo(val:string,_event: any,index:any){
    if(_event.isUserInput){
    this.standard = val;
    console.log('standard',this.standard,val);
    }
  }
save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }
  this.data = {
    samplingtime:this.form.controls.samplingtime.value,
    name:this.form.controls.name.value,
    tool:this.form.controls.tool.value,
    toolCode:this.form.controls.toolCode.value,
    spot:this.form.controls.spot.value,
    lcl:this.form.controls.lcl.value,
    ucl:this.form.controls.ucl.value,
    lsl:this.form.controls.lsl.value,
    usl:this.form.controls.usl.value,

    tb118f_id:this.selectedSymbolCtrl.value,
    //lsl:parseFloat(this.form.controls.limit.value)-parseFloat(this.form.controls.uncertainty_low.value),
    //usl:parseFloat(this.form.controls.limit.value)+parseFloat(this.form.controls.uncertainty_high.value),
    remark:this.form.controls.remark.value,
    lot:this.selectedLotCtrl.value,

    model:this.selectedItemsModel,
    line:this.selectedItemsLine,
    process:this.selectedItemsProcess,
    standard:this.selectedItemsStand,
    
    //xbar:this.xbar,
    xbar:this.form.controls.xbar.value,
    cpk:this.form.controls.cpk.value,
    cp:this.form.controls.cp.value,
    rbar:this.form.controls.rbar.value,
    uclr:this.form.controls.uclr.value,
    filename:this.fileupload
  }
  // insert data
  this.httpservice.fetchpost('insertPostDataControlChart.php', this.data, (cb) => {});
  //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }

  this.form.reset();
  this.selectedProductCtrl.reset();
  this.selectedLineCtrl.reset();
  this.selectedLotCtrl.reset();
  this.selectedModelCtrl.reset();
  this.selectedProcessCtrl.reset();
  this.selectedSymbolCtrl.reset();
  this.selectedItemsStand = [];
  this.selectedItemsLine = [];
  this.selectedItemsProcess = [];
  this.selectedItemsModel = [];

}

search(){ 
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_control_chart.php?key='+this.key,(ctchart) => {
    this.rows = ctchart;
    //this.temp = ctchart;
    console.log('------this.machine------', this.key,ctchart,this.rows);
  });
  this.ctrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      product: [null, Validators.compose([Validators.required])],
      tool: [null, Validators.compose([Validators.required])],
      toolCode: [null, Validators.compose([Validators.required])],
      spot: [null, Validators.compose([Validators.required])],
      lcl: [null, Validators.compose([Validators.required])],
      ucl: [null, Validators.compose([Validators.required])],
      lsl: [null, Validators.compose([Validators.required])],
      usl: [null, Validators.compose([Validators.required])],
      xbar: [null, Validators.compose([Validators.required])],
      rbar: [null, Validators.compose([Validators.required])],
      cpk: [null, Validators.compose([Validators.required])],
      cp: [null, Validators.compose([Validators.required])],
      uclr: [null, Validators.compose([Validators.required])],
      remark: [null, Validators.compose([Validators.required])],
      samplingtime: [null, Validators.compose([Validators.required])],
      uncertainty_high:[null, Validators.compose([Validators.required])],
      uncertainty_low:[null, Validators.compose([Validators.required])],
      limit:[null, Validators.compose([Validators.required])]

    });
  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }


    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tb86f_ctc_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }
  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.standard_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  

  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }

  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(controlChartSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(controlChartSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value!=null && this.form.controls.lcl.value && this.form.controls.ucl.value !="" && this.form.controls.lsl.value !="" && this.form.controls.usl.value !=""){
          this.edit();
        }else{
          this.warningDialog('Please fill in name, lcl , ucl !');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(controlChartSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.form.controls.name.value!=null && this.form.controls.ucl.value && this.form.controls.lcl.value !="" && this.form.controls.lsl.value !="" && this.form.controls.usl.value !=""){
          this.save();
        }else{
          this.warningDialog('Please fill in name, lsl,usl,lcl and ucl value!');
        }
      
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningControlChartSettingDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'control-chart-setting-dialog',
  templateUrl: 'dialog.html',
})
export class controlChartSettingDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<controlChartSettingDialog>) {}
}

//warning
@Component({
  selector: 'warning-control-chart-setting-dialog',
  templateUrl: 'warning.html',
})
export class WarningControlChartSettingDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningControlChartSettingDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/control-chart-setting/control-chart-setting.ts